var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user || _vm.employee)?_c('user-modal',{attrs:{"user":_vm.user,"employee":_vm.employee}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }